import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import purchaseOrderRoutes from "~produce/purchasing/orders/helpers/purchaseOrderRoutes";

export const PURCHASE_ORDER_TARGET_KIND = "purchaseOrder";
export const FULFILL_PURCHASE_ORDER_TARGET_KIND = "fulfillPurchaseOrder";
export const PURCHASE_ORDERS_DOCK_PAGE_ID = "purchase-orders";
export const FULFILL_PURCHASE_ORDERS_DOCK_PAGE_ID = "purchasing-orders";
const PURCHASE_ORDER_ROUTE_PATTERN = /^\/(?:produce|fulfill)\/purchasing\/orders\/([^/?#]+)$/;
const CREATE_SEGMENT = "new";

export const purchaseOrderTargetKindFor = (purchaseOrdersPath: string): string =>
	purchaseOrdersPath === purchaseOrderRoutes.FULFILL_PURCHASE_ORDERS_PATH
		? FULFILL_PURCHASE_ORDER_TARGET_KIND
		: PURCHASE_ORDER_TARGET_KIND;

export const matchPurchaseOrderReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = PURCHASE_ORDER_ROUTE_PATTERN.exec(pathname);
	if (!match || match[1] === CREATE_SEGMENT) return null;
	try {
		return {
			targetId: decodeURIComponent(match[1]),
			targetKind: purchaseOrderTargetKindFor(purchaseOrderRoutes.resolvePurchaseOrdersPath(pathname))
		};
	} catch {
		return null;
	}
};

const purchaseOrderReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId, targetKind }) =>
		`${
			targetKind === FULFILL_PURCHASE_ORDER_TARGET_KIND
				? purchaseOrderRoutes.FULFILL_PURCHASE_ORDERS_PATH
				: purchaseOrderRoutes.PRODUCE_PURCHASE_ORDERS_PATH
		}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchPurchaseOrderReceiverRoute
};

export default purchaseOrderReceiverIdentityAdapter;
